<template>
  <div class="footer col-block">
    <div class="info-list-container col-block" v-for="(infoOptions, iloindex) in infoListOptions" :key="iloindex">
      <joinComponent
        :type="'row'"
        :gap="'0.3rem'"
      >
        <span slot="separator">|</span>
        <div class="info-list-block row-block" v-for="(infoOption, ioindex) in infoOptions.options" :key="ioindex" :slot="'slot-' + (ioindex + 1)">
          <div v-if="infoOption.icon" class="info-icon center-block">
            <img :src="infoOption.icon.src" alt="" :style="infoOption.icon.width ? { 'max-width': infoOption.icon.width } : {}">
          </div>
          <div
            v-if="infoOption.title"
            class="info-title"
            :style="infoOption.titleStyle"
            v-html="infoOption.title"
            @click="e => selectedAdress = infoOption.title"
          ></div>
          <component
            v-if="infoOption.content"
            class="info-content link main no-line"
            :is="infoOption.content.link ? 'a' : 'div'"
            :href="infoOption.content.link"
          >{{ infoOption.content.text }}</component>
          <template v-if="infoOption.custom === 'language'">
            <div class="info-language-container row-block">
              <div class="info-language-block row-block">
                <span v-if="!infoOption.title">[</span>
                <div
                  class="info-language-content-container row-block"
                  v-for="(option, loindex) in languageOptions"
                  :key="loindex"
                  :class="{ active: option.value === locale }"
                  @click="e => setLang(option.value)"
                >
                  <div class="info-language-content">{{ option.title }}</div>
                  <span v-if="languageOptions[loindex + 1]">-</span>
                </div>
                <span v-if="!infoOption.title">]</span>
              </div>
            </div>
          </template>
        </div>
      </joinComponent>
    </div>
  </div>
</template>

<script>
import joinComponent from '../tool/joinComponent.vue'
import responsitive from '../../mixins/responsitive.vue'
import locale from '../../mixins/locale.vue'

export default {
  components: {
    joinComponent
  },
  mixins: [
    responsitive,
    locale
  ],
  data () {
    return {
      selectedAdress: 'JP'
    }
  },
  computed: {
    // static
    infoListOptions () {
      return [
        {
          options: [
            {
              icon: {
                src: require('../../assets/icons/compassbioinfo-icon.svg'),
                width: '16px'
              },
              content: {
                text: this.$t('LAYOUT.footer.___companyTitle')
              },
              custom: this.isMobile ? 'language' : ''
            }
          ]
        },
        {
          options: [
            {
              title: 'US',
              titleStyle: (this.selectedAdress === 'US' && this.isMobile) ? { color: '#003679' } : {},
              content: (this.selectedAdress === 'US' || !this.isMobile) ? {
                text: '13400 Briarwick Drive, Unit 103, Austin, TX 78728'
              } : null
            },
            {
              title: 'TW',
              titleStyle: (this.selectedAdress === 'TW' && this.isMobile) ? { color: '#003679' } : {},
              content: (this.selectedAdress === 'TW' || !this.isMobile) ? {
                text: '新竹市東區慈雲路118號17樓之10'
              } : null
            },
            {
              title: 'JP',
              titleStyle: (this.selectedAdress === 'JP' && this.isMobile) ? { color: '#003679' } : {},
              content: (this.selectedAdress === 'JP' || !this.isMobile) ? {
                text: '東京都港区西新橋一丁目6番12号アイオス虎ノ門803室'
              } : null
            }
          ]
        },
        {
          options: [
            {
              title: 'Phone',
              content: {
                text: '+886 3-5745009'
              }
            },
            {
              title: 'Email',
              content: {
                text: 'service@compassbioinfo.com',
                link: 'mailto:service@compassbioinfo.com'
              }
            },
            ...!this.isMobile ? [
              {
                title: 'Language',
                custom: 'language'
              }
            ] : []
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue